import { createRouter, createWebHistory } from 'vue-router';
import Page from "../views/page/Page.vue";

const routes = [
    {
        path: '/construction-work',
        name: "filter",
        component: Page,
        props: {
            isArchiveMode: false
        }
    },
    {
        path: '/construction-work/archive',
        name: "filter-archive",
        component: Page,
        props: {
            isArchiveMode: true
        }
    },
];

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    routes: routes,
});

export default router;
